// MVR Constants
export const MVR_ERR1 = 'SERVICE TEMPORARILY UNAVAILABLE';
export const MVR_ERR2 = 'DMV CLOSED OR DOWN FOR SCHEDULED MAINTENANCE';
export const MVR_ERR3 = 'REQUESTED STATE IS DISABLED BY LEXISNEXIS';
